import React from 'react';
import { useDispatch } from 'react-redux';

import interact from 'interactjs';
import { TimelineMax as Timeline, Power1 } from 'gsap';

import CloseIcon from '../icons/close.svg';

import { showSidebar, useSidebar } from '../slices/ui'


class Sidebar extends React.Component {

    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.panel = React.createRef();
        this.escFunction = this.escFunction.bind(this);
        this.dragStartHandler = this.dragStartHandler.bind(this);
        this.dragMoveHandler = this.dragMoveHandler.bind(this);
        this.dragEndHandler = this.dragEndHandler.bind(this);
        this.clickHandler = this.clickHandler.bind(this);
        this.dragDirection = 'x';
        this._dragMove = null;
        this._currentSize = null;
        this._lastFocusOutside = null;
    }

    componentDidMount() {
        
        this.interact = interact(this.panel.current).draggable({
             onstart: this.dragStartHandler,
             onmove: this.dragMoveHandler, 
             onend: this.dragEndHandler,
             startAxis: 'x',
             lockAxis: 'x',
        }).on('tap', this.clickHandler);

        this.updateTimeLine();
        this.updateStatus();
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
        this.timeline.clear();
        this.interact.unset();
        this.interact = null;
        this.timeline = null;
        this._lastFocusOutside = null;
    }

    componentDidUpdate(prevProps){
        //if (this.props.IsOpen == prevProps.IsOpen && this.props.position == prevProps.position){
            //return false;
        //}

        if (this.props.position != prevProps.position){
            this.updateTimeLine();
        }

        if (this.props.isOpen != prevProps.isOpen){
            this.updateStatus();
        }

    }

    render() {
        let className = 'sidebar';
        if (this.props.position == 'right'){
            className += ' right';
        } else {
            className += ' left';
        }
        return (
            <aside ref={this.container} aria-hidden={(this.props.isOpen) ? "false":"true"} className={className} role="dialog">
               <div ref={this.panel} className="sidebar__panel">
                    <button onClick={this.props.closeSidebar}
                            className="sidebar__close button primary">
                        <CloseIcon/> 
                    </button>
                    <div className="sidebar__container scrollbar secondary">
                        {this.props.children}
                    </div>
                </div>
            </aside>
        )
    }

    escFunction(event){
        if(event.keyCode === 27) {
            this.props.closeSidebar();
        }
    }

    dragStartHandler(event){
        this._dragMove = 0;
        this._currentSize = this.panel.current.offsetWidth;
    }

    dragMoveHandler(event){
        const dragMove = (this.props.position == 'right') ? -event.dx : event.dx;
        this._dragMove =  this._dragMove + dragMove;
        if (this._dragMove < 0){
            this.timeline.pause()
            this.timeline.progress(1 + (this._dragMove / this._currentSize) / 1.5)
        }
    }

    clickHandler(event){
        if (!this.panel.current.contains(event.target)){
            this.props.closeSidebar();
        }
    }

    dragEndHandler(event){
        if (this.timeline.progress() > 0.5){
            this.timeline.play();
        } else {
            this.props.closeSidebar();
        }
    }

    updateTimeLine(){
        const finalPosition = (this.props.position == 'right') ? '100%' : '-100%';
        this.timeline = new Timeline({ paused: true });
        this.timeline.fromTo(
            this.container.current,
            {opacity:0, display:'none'},
            {opacity:1, display:'block', duration:0.1});

        this.timeline.fromTo(
            this.panel.current, 
            {x:finalPosition, display: 'none'}, 
            {x:'0%', display:'block', duration: 0.4});

        this.timeline.eventCallback('onComplete', ()=>{
            window.requestAnimationFrame(()=>{
                this.container.current.querySelector('button').focus();
            });
        })
    }

    updateStatus(){
        if (this.props.isOpen){
            document.addEventListener("keydown", this.escFunction, false); 
            this.timeline.play()
            this._lastFocusOutside = document.activeElement;
        } else {
            document.removeEventListener("keydown", this.escFunction, false);
            if (this._lastFocusOutside){
                this._lastFocusOutside.focus();
            }
            this.timeline.reverse()
        }
    }

}

const ConnectedSidebar = (props) => {
    const dispatch = useDispatch()
    const openedSidebar = useSidebar() 
    const ownprops = {
      ...props,
      isOpen: openedSidebar && openedSidebar === props.name,
      closeSidebar: () => dispatch(showSidebar())
    }
  return <Sidebar {...ownprops}/>
} 

export default ConnectedSidebar;
